import {MutationTree} from "vuex";
import {FavoritesState} from "@service/store/types/FavoritesState";
import {ObjectPair} from "@service/types/ObjectPair";
import state from "@share/chat/store/main/state";

export const mutations: MutationTree<FavoritesState> = {
    setList(state, newList) {
        state.list = newList;
    },
    setUnreadedItem(state, unreadedItemId) {
        !state.listIsOpened && document.hasFocus() && state.unreadedItems.push(unreadedItemId);
    },
    removeUnreadedItem(state, itemId) {
        !state.listIsOpened && document.hasFocus() && (state.unreadedItems = state.unreadedItems.filter((unreadedItemId) => unreadedItemId != itemId));
    },
    setUnreaded(state, payload) {
        state.unreadedItems = payload;
    },
    addNewFavorites(state, {schemaId, objectId}: ObjectPair) {
        if (!state.list[schemaId]) {
            state.list[schemaId] = [];
        }
        if (!state.list[schemaId].includes(objectId)) {
            state.list[schemaId].push(objectId);
        }
    },
    removeFromFavorites(state, {schemaId, objectId}: ObjectPair) {
        if (state.list[schemaId] && state.list[schemaId].length) {
            const index = state.list[schemaId].indexOf(objectId);
            index >= 0 && state.list[schemaId].splice(index, 1);
        }
    },
    setObserver(state, observer) {
        state.observer = observer;
    }
}
